import Feedback from './models'

export default Feedback
